import { render } from "./BackIcon.svg?vue&type=template&id=6519bc74"
const script = {}
script.render = render

export default script